// React
import React, { Children } from "react";

// External libraries
import { useAutoAnimate } from "@formkit/auto-animate/react";

// Internal
import { Panel } from "./panel";

function FormPanelBody(props) {
    const [body, enableAnimations] = useAutoAnimate();

    if (props.Loading) {
        const columns = Children.toArray(props.children);
        return columns.map((column, index) => {
            return (
                React.cloneElement(column, { key: index, Skeleton: true })
            );
        });
    }

    if (props.Animate) {
        return (
            <div className={props.BodyClass} ref={body} style={props.BodyStyle}>
                {props.children}
            </div>
        );
    }

    return (
        <div className={props.BodyClass} style={props.BodyStyle}>
            {props.children}
        </div>
    );
}

function FormPanel(props) {
    const getBodyStyle = () => {
        let style = props.BodyStyle || {};
        if (props.Grow) {
            style.display = "flex";
            style.flexDirection = "column";
            style.flexGrow = 1;
            style.minHeight = 0;
        }
        return style;
    }

    const collapseHandler = (value) => {
        if (typeof props.OnCollapse === "function") {
            props.OnCollapse(value);
        }
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    return (
        <Panel
            MaxHeightWithBreadcrumb={props.MaxHeightWithBreadcrumb}
            PanelClass={props.PanelClass}
            Icon={props.Icon}
            IconType={props.IconType}
            IconStyle={props.IconStyle}
            Title={props.Title}
            Explanation={props.Explanation}
            ExplanationString={props.ExplanationString}
            HeaderButtons={props.HeaderButtons}
            Visible={props.Visible}
            BodyClass={"eone-ui-panel-form-content"}
            BodyStyle={props.PanelBodyStyle}
            BodyHeight={props.BodyHeight}
            Style={props.Style}
            TooltipInfo={props.TooltipInfo}
            Collapsible={props.Collapsible}
            Collapsed={props.Collapsed}
            OnCollapse={collapseHandler}
            DataTestId={props.DataTestId}>

            <FormPanelBody
                Loading={props.Loading}
                Animate={props.Animate}
                BodyStyle={getBodyStyle()}
                BodyClass={props.BodyClass} >
                {props.children}
            </FormPanelBody>

        </Panel>
    );
}

export { FormPanel };